<div class="page_layout">
  <app-page-title-gold input_title="{{ MenuTitle() }}" />
  <app-categories-scroller
    (categorySelected)="onCategorySelected($event)"
    [inputid]="categoryId"
  />
  @if (category) { @if(language == 'En'){
  <app-page-title-gold [input_title]="category.nameEn" />
  } @else if(language == 'Ar'){
  <app-page-title-gold [input_title]="category.nameAr" />
  } @else if(language == 'Tr'){
  <app-page-title-gold [input_title]="category.nameTr" />
  } }
  <div class="body">
    @for (item of menuItems; track item.id) { @if (item.isVisible) {
    <app-menu-item-card [MenuItemID]="item.id" />
    } @if (couponStatusMap.get(item.id)) {
    <app-cupon [menuItemId]="item.id" />
    } }
  </div>
  <app-menu-footer />
</div>
